import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssociateExpertWithRule, ExpertDeliveryRulesSchema, ExpertRules } from 'src/app/models/expert-delivery-rules.schema';
import { Expert } from 'src/app/models/expert.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { ExpertDeliveryRulesService } from 'src/app/services/expert-delivery-rules.service';
import { ExpertService } from 'src/app/services/expert.service';

@Component({
  selector: 'app-expert-delivery-rules-form',
  templateUrl: './expert-delivery-rules-form.component.html',
  styleUrls: ['./expert-delivery-rules-form.component.scss']
})
export class ExpertDeliveryRulesFormComponent implements OnInit {

  groups: string[];
  ruleId: string;
  expertDeliveryRule: ExpertDeliveryRulesSchema;
  expertDeliveryRulesForm: any;
  formValidationMsgs: any;
  experts: Expert[] = [];
  tmpBtnDisabled: boolean;
  days: { selected: boolean }[] = [
    { selected: false },
    { selected: false },
    { selected: false },
    { selected: false },
    { selected: false },
    { selected: false },
    { selected: false }
  ];
  weekDays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authStatusService: AuthStatusService,
    private expertService: ExpertService,
    private expertDeliveryRulesService: ExpertDeliveryRulesService,
    private commanUsesService: CommanUsesService,
  ) { 
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
      this.formValidationMsgs = ExpertDeliveryRulesSchema.validationMessages;
      this.handleExpertDeliveryRulesForm();
    }
    catch {
      this.groups = [];
    }
  }

  async ngOnInit() {
    try {
      await this.getAllActiveExperts();
      const ruleId: string = this.route.snapshot.paramMap.get('id');
      this.ruleId = ruleId;
      if (this.ruleId) {
        this.expertDeliveryRule = await this.expertDeliveryRulesService.getOne(Number(this.ruleId));
      }
      // console.log("this.expertDeliveryRule", this.expertDeliveryRule);
      // return
      if (this.expertDeliveryRule) {
        this.patch();
      } else {
        this.expertDeliveryRule = new ExpertDeliveryRulesSchema();
      }
    } catch (error) {
      console.log("ERROR", error);
      // this.router.navigateByUrl("/404", { skipLocationChange: true });
    }
  }

  handleExpertDeliveryRulesForm(){
    this.expertDeliveryRulesForm = new FormGroup(ExpertDeliveryRulesSchema.validation());
    this.formValidationMsgs = ExpertDeliveryRulesSchema.validationMessages;
  }

  async getAllActiveExperts(){
    try {
      // this.experts = (await this.expertService.getAllActiveExperts(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' })).experts;
      this.experts = await this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts);
    }catch { }
  }

  patch() {
    if (this.expertDeliveryRule.expert){
      this.expertDeliveryRulesForm.controls.expert.controls.id.setValue(this.expertDeliveryRule.expert.id);
    }

    const rulesArray = this.expertDeliveryRulesForm.get('rules') as FormArray;
    rulesArray.clear();
    let rules = this.expertDeliveryRule.rules && typeof this.expertDeliveryRule.rules === 'string' ? JSON.parse(this.expertDeliveryRule.rules) : [];
    if (rules && rules.length > 0) {
      rules.forEach(rule => {
        const ruleGroup = ExpertRules.createFormGroup();
        ruleGroup.patchValue({
          operator: rule.operator || 'equal',
          pickUps: rule.pickUps || 0,
          plusSalary: rule.plusSalary || 0,
        });
        rulesArray.push(ruleGroup);
      });
    }

    if(this.expertDeliveryRule.associateExpertWithRule.length > 0) {
      this.patchAssociatePartners();
    }
  }

  patchAssociatePartners(){
    const control = <FormArray>this.expertDeliveryRulesForm.get('associateExpertWithRule');
    control.clear();
    if (!this.expertDeliveryRule.associateExpertWithRule || Array.isArray(this.expertDeliveryRule.associateExpertWithRule) && this.expertDeliveryRule.associateExpertWithRule.length == 0){
      this.expertDeliveryRule.associateExpertWithRule = [new AssociateExpertWithRule()];
    }
    this.expertDeliveryRule.associateExpertWithRule.forEach((f, index) => {
      control.push(this.patchpatchAssociatePartnerValues(f, index));
    });
  }

  patchpatchAssociatePartnerValues(assoExpert: AssociateExpertWithRule, index: number) {
    let assoExpertDeliveryRule = ExpertDeliveryRulesSchema.associateExpertWithDeliveryRuleFormGroup();
    assoExpertDeliveryRule.controls.expert.setValue(
      { 
        id: assoExpert?.expert?.id, 
      }
    );
        
    return assoExpertDeliveryRule;
  }

  async onSubmit(){
    if(this.expertDeliveryRulesForm.valid){
      this.tmpBtnDisabled = true;
      let expertDeliveryRule: ExpertDeliveryRulesSchema = new FormGroupToObject().transform(this.expertDeliveryRulesForm);
      if(expertDeliveryRule.rules.length > 0) {
        expertDeliveryRule.rules = JSON.stringify(expertDeliveryRule.rules);
      }
      if(expertDeliveryRule?.associateExpertWithRule[0]?.expert?.id === null || expertDeliveryRule?.associateExpertWithRule[0]?.expert?.id === undefined || expertDeliveryRule?.associateExpertWithRule[0]?.expert?.id === ''){
        delete expertDeliveryRule?.associateExpertWithRule;
      }

      let promiseResult: any;
      if (this.expertDeliveryRule['id']) {
        promiseResult = this.expertDeliveryRulesService.updateExpertDeliveryRule(this.expertDeliveryRule['id'], expertDeliveryRule);
      } else {
        promiseResult = this.expertDeliveryRulesService.create(expertDeliveryRule);
      }
      let message: string = this.expertDeliveryRule['id'] ? "Valet Conegna Rule aggiornato" : "Valet Conegna Rule creato";
      promiseResult.then(async (response: any) => {
        this.tmpBtnDisabled = false;
        await this.commanUsesService.showSnackBar(message);
        await this.router.navigate(['/expert/rules']);
      }).catch(async (error: any) => {
        this.tmpBtnDisabled = false;
        await this.commanUsesService.showSnackBar(error.error.message);
      });
    }
  }

  addRule() {
    (this.expertDeliveryRulesForm.get('rules') as FormArray).push(ExpertRules.createFormGroup());
  }

  get rules(): FormArray {
    return this.expertDeliveryRulesForm.get('rules') as FormArray;
  }

  removeRule(index: number): void {
    this.rules.removeAt(index);
  }

  isAssociateExpertOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const experts of this.expertDeliveryRulesForm.value.associateExpertWithRule) {
      if (experts?.expert?.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId;
  }

  addAssociateExpert() {
    const control = <FormArray>this.expertDeliveryRulesForm.get('associateExpertWithRule');
    control.push(ExpertDeliveryRulesSchema.associateExpertWithDeliveryRuleFormGroup());
  }

  removeAssociateExpert(index: number) {
    const control = <FormArray>this.expertDeliveryRulesForm.get('associateExpertWithRule');
    control.removeAt(index);
  }

}
